import { InformationDetailPanelSection } from '../InformationDetailPanelSection'
import { 
    LICENCED_EXEMPT, 
    LICENCED_INDIVIDUAL, 
    LICENCED_UNDER_BROKERAGE, 
    NOT_LICENCED 
} from "../../../../redux/slice/primaryAgencyApplicationSlice"

export const BrokerPreviousLicenceDetails = (props) => {
    const {
        appData
    } = props

    const {
        previouslyLicencedStatus
    } = appData

    let previousLicenceString = ""

    switch(previouslyLicencedStatus) {
        case LICENCED_INDIVIDUAL : 
            previousLicenceString = "This applicant was licensed as an individual for at least 24 out of the last 36 months"
            break
        case LICENCED_UNDER_BROKERAGE : 
            previousLicenceString = "This applicant was licensed as part of a brokerage under for at least 24 out of the last 36 months"
            break
        case LICENCED_EXEMPT : 
            previousLicenceString = "This applicant was exempt because the applicant brokered mortgages for a federally regulated financial institution"
            break
        case NOT_LICENCED : 
            previousLicenceString = "The applicant was licensed for less than 24 out of the last 36 months, never exempt, or is choosing to apply for an Associate Mortgage Broker licence"
            break
        default : 
            previousLicenceString = "N/A"
            break
    }

    return (
        <div style={{marginTop: "1em"}}>
            <InformationDetailPanelSection 
                header={"Previous licence status"} 
                value={previousLicenceString} />
        </div>
    )
}
